<template>
  <div class="p-service">
    <div class="p-block">
      <div class="p-block-title">
        <p class="main">{{ baseData.title }}</p>
        <p class="sub">{{ baseData.subtitle }}</p>
      </div>
    </div>
    <ul>
      <li v-for="(item, index) in baseData.list" :index="index" :key="index">
        <p>
          <img :src="item.icon" />
        </p>
        <p>{{ item.name }}</p>
        <p>{{ item.desc }}</p>
      </li>
    </ul>
    <div class="p-block-more">
      <kd-link
        type="primary"
        @click="
          $emit('homeCallback', {
            dwClickName: 'learn_more_smart_plat',
          })
        "
      >
        <KdIcon
          icon="ArrowRightS"
          :size="24"
          fill="currentColor"
          margin="0 0 0 3px"
          leftText="点击咨询，了解更多"
          textSize="18"
        ></KdIcon>
      </kd-link>
    </div>
  </div>
</template>

<script>
import { serviceData } from '@/views/homeV2/config.js';
import KdIcon from '@/components/KdIcon/index.vue';
export default {
  name: 'service-component',
  components: { KdIcon },
  data() {
    return {
      baseData: serviceData,
    };
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.p-service {
  position: relative;
  > ul {
    margin-top: 40px;
    text-align: center;
    li {
      text-align: left;
      width: 384px;
      height: 292px;
      border-radius: 12px;
      border-width: 1px;
      padding: 32px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      box-shadow: 0px 4px 20px 0px rgba(13, 13, 13, 0.03);
      margin-bottom: 24px;
      margin-right: 24px;
      display: inline-block;
      vertical-align: middle;
      &:last-child {
        margin-right: 0;
      }

      p:nth-child(1) {
        img {
          width: 80px;
          height: 80px;
        }
      }
      p:nth-child(2) {
        margin-top: 24px;
        font-weight: 600;
        font-size: 24px;
        line-height: 38px;
        color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
      }
      p:nth-child(3) {
        margin-top: 8px;
        font-weight: 400;
        font-size: 16px;
        line-height: 160%;
        color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
      }
    }
  }
  @include responsiveV2($width-m) {
    > ul {
      width: 840px;
      margin: 40px auto 0 auto;
      li {
        width: 242px;
        height: 318px;
        padding: 24px;
        box-sizing: border-box;
        &:nth-child(3n) {
          margin-right: 0 !important;
        }
      }
    }
  }
}
</style>
